export default __webpack_public_path__ + "static/media/sensu.6231492c.svg";